var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"loading":_vm.loading,"title":`Sala - ${_vm.infraestrutura.nome} (${_vm.centroCusto.setorNome})`,"large":"","hide-footer":""}},[_c('Form',{ref:"Form",attrs:{"centroCusto":_vm.centroCusto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }